import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "./App.css";
import "./styles/seims.css";

import CustomLayout from "./containers/CustomLayout";
import LookupSyncBanner from "./common/components/LookupSyncBanner";
import { logoutInstanceEventListener } from "@seims/shared/src/security";

function App({failedStart, message}) {
  const location = useLocation();
  const [authInit, setAuthInit] = useState(false);
  // const TRACKING_ID = "G-9M3CLY03J3";
  const navigate = useNavigate();
  const formRef = useRef();
  const allowPullToRefresh = location.pathname === "/events";


  //This is disabled at the moment because of the Global (from index.html page) setting which will be moved to this component so that Google Analytics tracking can be managed
  //ReactGA.initialize(TRACKING_ID);
  useEffect(() => {
    // Google Analytics tracking is currently disabled
    //ReactGA.pageview(window.location.pathname + window.location.search);
    logoutInstanceEventListener();
    setAuthInit(failedStart);

    if (failedStart) {

      let path = `/autherror`;
      navigate(path, { state: { message: message } });
    }
    else 
    {
      navigate(location.pathname);
    }

  }, [failedStart]);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    const html = document.documentElement;
    const body = document.body;
    const previousHtmlOverscroll = html.style.overscrollBehaviorY;
    const previousBodyOverscroll = body.style.overscrollBehaviorY;

    if (allowPullToRefresh) {
      html.style.overscrollBehaviorY = previousHtmlOverscroll;
      body.style.overscrollBehaviorY = previousBodyOverscroll;
      return undefined;
    }

    let touchStartY = 0;

    const handleTouchStart = (event) => {
      if (event.touches?.length === 1) {
        touchStartY = event.touches[0].clientY;
      }
    };

    const handleTouchMove = (event) => {
      if (event.touches?.length !== 1) {
        return;
      }

      const currentY = event.touches[0].clientY;
      const isPullingDown = currentY > touchStartY;
      const isAtTop = window.scrollY <= 0;

      if (isAtTop && isPullingDown) {
        event.preventDefault();
      }
    };

    html.style.overscrollBehaviorY = "none";
    body.style.overscrollBehaviorY = "none";

    document.addEventListener("touchstart", handleTouchStart, { passive: true });
    document.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
      html.style.overscrollBehaviorY = previousHtmlOverscroll;
      body.style.overscrollBehaviorY = previousBodyOverscroll;
    };
  }, [allowPullToRefresh]);

  return (
    <div className="App">
      <CustomLayout />
    </div>
  );
}

export default App;
